import { Schema } from "@comparaonline/products-schema";
import { ProductAttribute } from "@comparaonline/offers-models";
import MainAttribute from "@comparaonline/ui-offer-main-attribute";
import React from "react";

export const Attribute: React.FC<Schema.ProductListProductAttribute> = props => (
  <MainAttribute gridProps={{ alignItems: "flex-start" }} {...(props as ProductAttribute)} />
);
